var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMoon = function SvgMoon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3541 15.354C18.7173 16.0122 16.9232 16.1748 15.1947 15.8217C13.4662 15.4686 11.8797 14.6153 10.6322 13.3678C9.38478 12.1204 8.53145 10.5338 8.17833 8.80535C7.8252 7.0769 7.98785 5.28277 8.64605 3.646C6.70776 4.42673 5.10141 5.85739 4.10238 7.69272C3.10334 9.52805 2.77384 11.6537 3.17037 13.7054C3.56689 15.757 4.66474 17.6069 6.27571 18.9378C7.88668 20.2687 9.91044 20.9977 12.0001 21C13.797 21.0001 15.5528 20.4624 17.0416 19.4562C18.5304 18.45 19.684 17.0213 20.3541 15.354Z",
    stroke: "var(--color-2)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Moon.521f55a3.svg";
export { ForwardRef as ReactComponent };